import { Box, Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { StyledImg } from '../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../elements/molecules/stack/Stack';

export function OsasHsdqIntro(props: { onClick: () => void }) {
    return (
        <CustomContainer>
            <Box
                backgroundColor="white"
                padding={8}
            >
                <Stack>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        Welke klachten ervaar je?
                    </Heading>
                </Stack>

                <Stack>
                    <StyledImg
                        alt="HSDQ vragenlijst introductie"
                        src="/assets/images/somnology/questionnaires/slapend-meisje.png"
                    />
                </Stack>

                <Stack>
                    <Text>
                        Beantwoord 32 vragen over slaapstoornissen (HSDQ, Holland Sleep Disorder Questionnaire). Zo kan
                        de slaaparts een idee krijgen van wat er aan de hand kan zijn met je slaap. Het gaat over de
                        klachten die je had <b>in de afgelopen drie maanden.</b>
                    </Text>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.onClick}
                        variant="solid"
                        width="full-below-small"
                    >
                        Beantwoord vragen
                    </Button>
                </ButtonRow>
            </Box>
        </CustomContainer>
    );
}
